import { doc } from "firebase/firestore";
import { P1, P2, EMPTY, createInitialConnect4State } from "./connectFour";

export function getConnect4LeaderboardRef(database, sessionId, lobbyName) {
  return doc(
    database,
    `lobbies/${sessionId}/lobby/${lobbyName}/state/connect4Leaderboard`
  );
}

/** Build leaderboard patch after a round ends (increments series score once). */
export function buildLeaderboardAfterRound(existing, roundState, names = {}) {
  const prev = existing && typeof existing === "object" ? existing : {};
  let player1Wins = Number(prev.player1Wins || 0);
  let player2Wins = Number(prev.player2Wins || 0);
  let draws = Number(prev.draws || 0);

  const status = String(roundState?.status ?? "");
  const winner = Number(roundState?.winner);

  if (status === "won") {
    if (winner === P1) player1Wins += 1;
    else if (winner === P2) player2Wins += 1;
  } else if (status === "draw") {
    draws += 1;
  }

  return {
    player1UserId: String(roundState?.player1UserId ?? prev.player1UserId ?? ""),
    player2UserId: String(roundState?.player2UserId ?? prev.player2UserId ?? ""),
    player1Name: String(names.player1Name ?? prev.player1Name ?? "Player 1"),
    player2Name: String(names.player2Name ?? prev.player2Name ?? "Player 2"),
    player1Wins,
    player2Wins,
    draws,
    lastRoundStatus: status,
    lastRoundWinner: winner === P1 || winner === P2 ? winner : EMPTY,
    updatedAtMs: Date.now(),
    rematch: {
      status: "idle",
      requestedBy: "",
      confirmed: {},
    },
  };
}

export function parseLeaderboardDoc(data) {
  if (!data || typeof data !== "object") return null;
  const confirmed =
    data?.rematch?.confirmed && typeof data.rematch.confirmed === "object"
      ? data.rematch.confirmed
      : {};
  return {
    player1UserId: String(data.player1UserId ?? ""),
    player2UserId: String(data.player2UserId ?? ""),
    player1Name: String(data.player1Name ?? "Player 1"),
    player2Name: String(data.player2Name ?? "Player 2"),
    player1Wins: Number(data.player1Wins) || 0,
    player2Wins: Number(data.player2Wins) || 0,
    draws: Number(data.draws) || 0,
    lastRoundStatus: String(data.lastRoundStatus ?? ""),
    lastRoundWinner: Number(data.lastRoundWinner) || EMPTY,
    rematch: {
      status: String(data?.rematch?.status ?? "idle"),
      requestedBy: String(data?.rematch?.requestedBy ?? ""),
      confirmed,
    },
    updatedAtMs: Number(data.updatedAtMs) || 0,
  };
}

export function bothPlayersConfirmedRematch(lb, player1Id, player2Id) {
  const c = lb?.rematch?.confirmed || {};
  return Boolean(c[player1Id] && c[player2Id]);
}

export function buildFreshConnect4ForRematch(lb, mode, cpuPlayer) {
  const fresh = createInitialConnect4State({
    player1UserId: lb.player1UserId,
    player2UserId: lb.player2UserId,
    mode,
    cpuPlayer,
  });
  fresh.player1Wins = lb.player1Wins;
  fresh.player2Wins = lb.player2Wins;
  return fresh;
}
